import { render, staticRenderFns } from "./SettingsOther.vue?vue&type=template&id=d4396db8&scoped=true&"
import script from "./SettingsOther.vue?vue&type=script&lang=js&"
export * from "./SettingsOther.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4396db8",
  null
  
)

export default component.exports